// @flow
export const SUBSIDY_TYPES_FILTER_CLEAR: 'reports/SUBSIDY_TYPES_FILTER_CLEAR' = 'reports/SUBSIDY_TYPES_FILTER_CLEAR';
export const SUBSIDY_TYPES_FILTER_DELETE: 'reports/SUBSIDY_TYPES_FILTER_DELETE' = 'reports/SUBSIDY_TYPES_FILTER_DELETE';
export const SUBSIDY_TYPES_FILTER_SET: 'reports/SUBSIDY_TYPES_FILTER_SET' = 'reports/SUBSIDY_TYPES_FILTER_SET';
export const SUBSIDY_TYPES_FILTER_UPDATE: 'reports/SUBSIDY_TYPES_FILTER_UPDATE' = 'reports/SUBSIDY_TYPES_FILTER_UPDATE';
